import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../../../fulfillment-planner/labeled-row/messages';

import LabeledRow from '../../../fulfillment-planner/labeled-row';

import style from './style.module.less';

const RequestedService = () => {
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.requestedService} />} labelClassName={style.label}>
      <span className={style.info}>
        <FormattedMessage {...messages.requestedServiceLocalDelivery} />
      </span>
    </LabeledRow>
  );
};

export default RequestedService;
